module.exports = __webpack_public_path__ + "static/media/559.ad02914b.png";